export default {
    word1: "EBC外汇平台顶级监管的差价合约(CFD)交易商|EBC金融集团",
    word2:
      "EBC金融集团是外汇金融衍生品交易平台，拥有多张全球顶级监管牌照，提供外汇、股票、指数和大宗商品的差价合约服务，是巴萨官方外汇合作伙伴。EBC旨在为投资者提供安全、专业、高效稳定的服务。",
    word3: "全球最佳券商",
    word4: `EBC金融集团<span class="subtitle-20_medium md-body-14_medium">100+</span>国家投资者信任首选`,
    word5: "杠杆率高达",
    word6: "主流投资产品",
    word7: "银行级原始点差",
    word8: "EBC携手联合国基金会共同打败疟疾",
    word9: `EBC跟单社区<br class="pc"/>免费复制高手收益`,
    word10: "免费跟随顶尖交易信号，或成为信号方赚最高 18% 年化收益",
    word11: "公开透明",
    word12: "一键跟随",
    word13: "赢18%年化奖励",
    word14: "持仓实时同步",
    word15: `EBC金融集团联合<br class="pc"/>牛津大学举办研讨会`,
    word16: "如何利用气候经济学， 挖掘投资机遇？ ",
    word17: "立即开户",
    word18: "了解更多",
    word19: "一键交易全球",
    word20:
      "涵盖全球200+ 主流投资产品，提供机构级流动性和极低点差，成就您的投资之旅",
    word21: "衍生品交易",
    word22: "贵金属及能源",
    word23: "全球股指",
    word24: "美国股票",
    word25: "ETF",
    word26: "交易产品",
    word27: "卖出价",
    word28: "买入价",
    word29: "点差",
    word30: "杠杆",
    word31: "更多产品",
    word32: "87.6%以上的订单成交于更优价格",
    word33:
      "EBC的交易黑盒精确优化订单算法，在价格优化率、订单执行率和算法稳定性方面超越传统交易系统",
    word34: "每秒最高聚合订单",
    word35: "平均执行速度",
    word36: "数据传输稳定性",
    word37: "银行级原始点差",
    word38: "基于百万次订单实盘验证，EBC订单优化率处于行业前2.5%的水平",
    word39: "开始交易",
    word40: "全球信赖首选 交易更安心 ",
    word41: "顶级监管资质，全面保障体系，让每一笔交易更安心",
    word42: "全面保障 安心以致",
    word43:
      "我们将资金安全置于首位。EBC英国及开曼将客户资金独立托管于英国巴克莱银行，并通过严格遵循英国FCA、开曼CIMA及澳大利亚ASIC监管要求，参与全球政府支持的保障性补偿计划，并通过英国劳合社获得多项企业专业险，为客户提供全面安全保障。",
    word44: "EBC全球合作伙伴",
    word45:
      "EBC与50+国际权威银行及非银机构建立长期稳定的合作关系，提供真正的机构流动性深度和 0.0 Pips同业级别原始点差 。此外，EBC联合牛津大学举办研讨会、与联合国基金会携手打败疟疾，并持续与全球合作伙伴合力，积极践行企业责任，推动建设可持续发展社会。",
    word46: "全球顶级监管",
    word47: "英国FCA监管",
    word48: "EBC Financial Group (UK) Ltd",
    word49: "由英国金融行为监管局 (FCA) 授权和监管。",
    word50: "监管号: 927552",
    word51: "开曼 CIMA 监管",
    word52: "EBC Financial Group (Cayman) Ltd",
    word53: "由开曼群岛金融管理局(CIMA)授权和监管。",
    word54: "监管号: 2038223",
    word55: "澳洲 ASIC 监管",
    word56: "EBC Financial Group (Australia) Pty Ltd",
    word57: "由澳大利亚证券和投资委员会 (ASIC) 授权和监管。",
    word58: "监管号: 500991",
    word59:
      "EBC金融集团旗下各公司，在对应司法管辖区域内，均受到严格监管并获得顶级资质许可。 ",
    word60:
      "从成立第一天起，我们就坚持最高的监管合规标准，始终将客户资产安全置于业务核心，这不仅是我们的承诺，更是不容谈判的原则。 ",
    word61:
      "您可以始终相信：我们只与顶级银行合作，严格遵守多地区监管框架，执行行业领先的风险管理协议。在安全、透明度和客户信任方面，我们从未，也永不妥协。 ",
    word62: "全球相伴 交易无忧",
    word63: "无论您身在何处，都能享受真诚专业的金融服务",
    word64: "月均交易量（美金）",
    word65: "注册用户",
    word66: "订单优化率",
    word67: "覆盖国家",
    word68: "与我们见面",
    word69: "英国团队（红色字体为地区团队名称）",
    word70: "新动态 新视野 新机会",
    word71:
      "实时获取EBC最新资讯，金融焦点、市场趋势、专业观点，为您筛选最有价值的信息",
    word72: "新闻",
    word73: "合作伙伴",
    word74: "留下您的信息",
    word75: "我们的客户经理会尽快联系您",
    word76: "提交",
    word77: "成交量",
    word78: "滑点",
    word79: "其他",
    word80: "十大最受欢迎券商",
    word81: "最透明交易券商",
    word82: "最受好评券商",
    word83: "卓越执行券商",
    word84: "全球最佳交易体验奖",
    word85: "最受信赖券商",
    word86: "最佳CFD券商",
    word87: "全球最佳ECN券商",
    word88: "全球新锐券商",
    word89: "OMA-最佳券商",
    word90: "最佳交易平台",
    word91: "最佳交易执行",
    word92: "全球最佳券商",
    word93: "贵姓/昵称",
    word94: "邮箱",
    word95: "手机号",
    word96: "验证码",
 
};
